import React from 'react';
import './progresoDashboard.css';

interface ProgresoGestion {
  PorcentajeAprobados: number;
  PorcentajePendientes: number;
  PorcentajeRechazados: number;
  TotalAprobados: number;
  TotalCups: number;
  TotalPendientes: number;
  TotalRechazados: number;
}

interface ProgresoDashboardProps {
  progresoGestion: ProgresoGestion;
}

const ProgresoDashboard: React.FC<ProgresoDashboardProps> = ({ progresoGestion }) => {
  const totalCups = Number(progresoGestion.TotalCups) || 0;
  const totalAprobados = Number(progresoGestion.TotalAprobados) || 0;
  const totalRechazados = Number(progresoGestion.TotalRechazados) || 0;
  const totalPendientes = Number(progresoGestion.TotalPendientes) || 0;

  const porcentajeAprobados = totalCups > 0 ? (totalAprobados / totalCups) * 100 : 0;
  const porcentajeRechazados = totalCups > 0 ? (totalRechazados / totalCups) * 100 : 0;
  const porcentajePendientes = totalCups > 0 ? (totalPendientes / totalCups) * 100 : 0;

  const porcentajeAprobadosSeguro = Math.max(0, Math.min(100, porcentajeAprobados));
  const porcentajeRechazadosSeguro = Math.max(0, Math.min(100, porcentajeRechazados));
  const porcentajePendientesSeguro = Math.max(0, Math.min(100, porcentajePendientes));

  const formatearPorcentaje = (valor: number): string => `${valor.toFixed(1)}%`;

  return (
    <div className="progreso-dashboard-container">
      <h4>Progreso de gestión del anexo</h4>
      
      <div className="dashboard-content">
        {/* Columna 1: Gráfico circular */}
        <div className="dashboard-chart-column">
          <div className="chart-circle">
            <svg width="120" height="120" viewBox="0 0 120 120">
              <circle
                cx="60"
                cy="60"
                r="50"
                fill="none"
                stroke="#e9ecef"
                strokeWidth="10"
              />
              {/* Círculo de progreso de aprobados */}
              <circle
                cx="60"
                cy="60"
                r="50"
                fill="none"
                stroke="#28a745"
                strokeWidth="10"
                strokeDasharray={`${(porcentajeAprobadosSeguro * 314) / 100} 314`}
                strokeDashoffset="0"
                transform="rotate(-90 60 60)"
              />
              {/* Círculo de progreso de rechazados */}
              <circle
                cx="60"
                cy="60"
                r="50"
                fill="none"
                stroke="#dc3545"
                strokeWidth="10"
                strokeDasharray={`${(porcentajeRechazadosSeguro * 314) / 100} 314`}
                strokeDashoffset={`-${(porcentajeAprobadosSeguro * 314) / 100}`}
                transform="rotate(-90 60 60)"
              />
            </svg>
          </div>
        </div>

        {/* Columna 2: Porcentajes con leyenda */}
        <div className="dashboard-percentages-column">
          <div className="legend-item">
            <span className="legend-color pendientes"></span>
            <span>Pendientes: <strong>{formatearPorcentaje(porcentajePendientesSeguro)}</strong></span>
          </div>
          <div className="legend-item">
            <span className="legend-color aprobados"></span>
            <span>Aprobados: <strong>{formatearPorcentaje(porcentajeAprobadosSeguro)}</strong></span>
          </div>
          <div className="legend-item">
            <span className="legend-color rechazados"></span>
            <span>Rechazados: <strong>{formatearPorcentaje(porcentajeRechazadosSeguro)}</strong></span>
          </div>
        </div>

        {/* Columna 3: Totales */}
        <div className="dashboard-totals-column">
          <div className="total-item">
            <span className="total-label">Total de CUPS:</span>
            <span className="total-value">{progresoGestion.TotalCups}</span>
          </div>
          
          <div className="total-item aprobados">
            <span className="total-label">Aprobados:</span>
            <span className="total-value">{progresoGestion.TotalAprobados}</span>
          </div>
          
          <div className="total-item rechazados">
            <span className="total-label">Rechazados:</span>
            <span className="total-value">{progresoGestion.TotalRechazados}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgresoDashboard;